var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{staticClass:"border-b-2 border-primary-500 px-3 pb-3 font-semibold text-base"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }